import { render } from "./FeatherMessageCircle.vue?vue&type=template&id=0f1ea342"
const script = {}
script.render = render

export default script